export enum ContentLoadingEnums {
  DEFAULT = 'sm',
  LG = 'lg',
}
